/*
 * Helper function for helping display campaign terms
 */
import { NonprofitAdminReferralCampaignResponse } from "@every.org/common/src/codecs/entities";
import { SafeInt } from "@every.org/common/src/codecs/number";
import { Currency } from "@every.org/common/src/entity/types.js";
import {
  displayCurrencyValue,
  minimumDenominationAmountToCurrencyValue,
} from "@every.org/common/src/helpers/currency.js";

export function campaignTermsToString(
  campaign: NonprofitAdminReferralCampaignResponse
) {
  const expirationDateLongStr = campaign.expirationDate?.toLocaleDateString(
    undefined,
    {
      timeZone: "America/Los_Angeles",
      month: "long",
      day: "numeric",
      year: "numeric",
    }
  );

  const expirationDateStr = campaign.expirationDate?.toLocaleDateString();
  const maxEarnedTotal = minimumDenominationAmountToCurrencyValue({
    currency: Currency.USD,
    amountInMinDenom: campaign.maxRewardAmount as SafeInt,
  });
  const rewardAmount = campaign.rewardAmount as SafeInt;

  const splitReward = minimumDenominationAmountToCurrencyValue({
    currency: Currency.USD,
    amountInMinDenom: rewardAmount,
  });
  const totalRewardMax = minimumDenominationAmountToCurrencyValue({
    currency: Currency.USD,
    amountInMinDenom: (rewardAmount *
      campaign.maxRedeemableCountPerReferral) as SafeInt,
  });
  const maxEarnedTotalStr = displayCurrencyValue({
    showCurrency: false,
    value: { amount: maxEarnedTotal.amount, currency: Currency.USD },
  }).formatted;
  const splitRewardStr = displayCurrencyValue({
    showCurrency: false,
    value: { amount: splitReward.amount, currency: Currency.USD },
  }).formatted;
  const totalRewardMaxStr = displayCurrencyValue({
    showCurrency: false,
    value: { amount: totalRewardMax.amount, currency: Currency.USD },
  }).formatted;
  return {
    expirationDateStr,
    maxEarnedTotalStr,
    splitRewardStr,
    totalRewardMaxStr,
    expirationDateLongStr,
  };
}
